<template>
    <div id="product-toolbar-container" class="product-toolbar-container">
        <div class="product-toolbar d-flex align-items-center">
            <div class="product-item-wrapper" v-for="product in productstoolbar" :key="product.product_id">
                <button class="product-icon-button" :class="{ 'is-default': product.is_default }"
                    :title="product.application"
                    @click="redirectToProduct(product.login_url)">
                    <img v-if="product.logo" :src="product.logo" :alt="product.application + ' Logo'"
                        class="product-logo-image" />
                    <span v-else class="logo-fallback">{{
                        product.application?.substring(0, 1)
                    }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductToolbar',
    data() {
        return {
            productstoolbar: [],
        }
    },

    async mounted() {
        this.init();
    },

    methods: {
        redirectToProduct(url) {
            const finalUrl = `${url}&org_selected=${this.orgID}`;
            window.open(finalUrl, '_blank');
        },

        async getData() {
            const authApiBaseUrl = process.env.VUE_APP_AUTH_API_BASE_URL;
            let url;
            const isRealSuperAdmin = this.$store.state.auth.jwtPayload?.roles?.includes('super_admin');
            if (isRealSuperAdmin || this.isOrgAdmin) {
                url = `${authApiBaseUrl}/orgadmin/organisations/${this.orgID}/product-toolbar`;
            } else {
                const userID = this.$store.state.auth.jwtPayload.user_id;
                url = `${authApiBaseUrl}/users/${userID}/product-toolbar`;
            }

            try {
                const response = await this.$axios_auth.get(url.replace(authApiBaseUrl + '/', ''));
                if (response.data.success) {
                    return response.data.toolbar_products;
                }
                return null;
            } catch (error) {
                console.error('ProductToolbar: Failed to fetch products', error);
                return null;
            }
        },

        async init() {
            const products = await this.getData();
            if (products) {
                this.filterProducts(products);
            }
        },

        filterProducts(products) {
            if (!Array.isArray(products)) {
                this.productstoolbar = [];
                return;
            }

            const isAdmin = this.isSuperAdmin || this.isOrgAdmin;

            let productToolbar;

            if (isAdmin) {
                const seenApplications = new Set();
                productToolbar = products.filter((item) => {
                    const appName = item.application?.toLowerCase();
                    if (
                        !appName ||
                        seenApplications.has(appName) ||
                        appName == 'xsurflog'
                    ) {
                        return false
                    } else {
                        seenApplications.add(appName)
                        return true
                    }
                })
            } else {
                productToolbar = products.filter(
                    (item) => {
                        const appName = item.application?.toLowerCase();
                        return appName !== 'xsurflog';
                    }
                )
            }

            this.productstoolbar = productToolbar.map(product => {
                return {
                    product_id: product.product_id,
                    application: product.application,
                    is_default: product.is_default,
                    logo: product.logo,
                    icon: product.icon,
                    login_url: `${product.login_url}?access_token=${this.$store.state.auth.accessToken}`
                };
            });
        },
    },

    computed: {
        orgID() {
            if (this.$store.state.auth.isSuperAdmin) {
                return this.$store.state.auth.organisation?.id || 0;
            }
            return this.$store.state.auth.org_id || 0;
        },
        isSuperAdmin() {
            return this.$store.state.auth.isSuperAdmin;
        },
        isOrgAdmin() {
            return this.$store.state.auth.isOrgAdmin;
        },
    },

    watch: {
        orgID() {
            this.init();
        }
    },
}
</script>

<style scoped>
/* Product toolbar styles */
.product-toolbar-container {
    padding: 3px;
}

.product-toolbar {
    min-height: 56px;
    position: relative;
    gap: 8px;
}

.product-item-wrapper {
    display: inline-block;
}

.product-icon-button {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: 2px solid #ffffff;
    background-color: #ffffff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    padding: 0;
    transition: transform 0.2s ease;
}

.product-icon-button:hover {
    transform: scale(1.1);
    z-index: 10;
}

.product-icon-button.is-default {
    border-color: #f3994d; /* Yellow/orange active border for default product */
}

.product-logo-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.logo-fallback {
    width: 100%;
    height: 100%;
    background-color: #333;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
